/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import ConfigusersPermissions from './ConfigusersPermissions'
import User from './User'

/**
 * The InlineResponse20030 model module.
 * @module model/InlineResponse20030
 * @version 1.0.0
 */
export default class InlineResponse20030 {
  /**
   * Constructs a new <code>InlineResponse20030</code>.
   * @alias module:model/InlineResponse20030
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20030</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20030} obj Optional instance to populate.
   * @return {module:model/InlineResponse20030} The populated <code>InlineResponse20030</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20030()

      if (data.hasOwnProperty('user')) {
        obj['user'] = User.constructFromObject(data['user'])
      }
      if (data.hasOwnProperty('permissions')) {
        obj['permissions'] = ApiClient.convertToType(data['permissions'], [ConfigusersPermissions])
      }
    }
    return obj
  }

  /**
   * @member {module:model/User} user
   */
  user = undefined
  /**
   * @member {Array.<module:model/ConfigusersPermissions>} permissions
   */
  permissions = undefined
}
